import LoadingButton from "@mui/lab/LoadingButton";

type ButtonProps = React.ComponentProps<typeof LoadingButton>;

export default function ButtonLoading(props: ButtonProps) {
  return <LoadingButton {...props} />;
}
